import React, { useContext } from 'react'
import { Segment, Button, Header, Divider, Container } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../../App/stores/RootStore';

const Deny = () => {
    const rootStore = useContext(RootStoreContext)
    const { closeModal } = rootStore.modalStore;

    return (
        <Segment clearing>
            <Header>Review Alert</Header>
            <Divider />
            <Container>
                STOP!
                You either do not have the appropriate Role to start this Review,
                   <Divider hidden />
                   You Have already been a Reviewer on this Request,
                   <Divider hidden />
                   or the review has been started by another user.
            </Container>
            <Divider />
            <Button
                floated='right'
                content="I shall not pass :("
                labelPosition='right'
                icon='frown'
                onClick={() => closeModal()}
                negative
            />
        </Segment>
    )
}
export default observer(Deny);